// Pure gating logic for the planner's "use the mobile app" prompt, extracted from PlanTrail.vue so
// the deterministic boundary/resize rules are unit-testable without mounting the map component.
//
// The planner is a desktop-only, mouse-oriented tool. On mobile web we don't load it — we show the
// "Open in app" prompt. "Mobile" = a mobile-UA device (any orientation) OR a narrow viewport, so a
// desktop window dragged below the threshold is gated too, matching the original width-based check.
import { isMobileDevice } from "../../utils/isMobileDevice";

export const PLANNER_MOBILE_MAX_WIDTH = 600;

/** Whether the planner should be gated for the given viewport width. */
export function isPlannerMobile(viewportWidth: number = window.innerWidth): boolean {
  return isMobileDevice() || viewportWidth < PLANNER_MOBILE_MAX_WIDTH;
}

/**
 * Next gate state on a viewport resize.
 * - If planner init was skipped (mounted on mobile, never initialised), stay gated regardless of the
 *   new width — revealing an uninitialised planner (e.g. a phone rotated into landscape past the
 *   threshold) would show a broken UI; it stays gated until reload.
 * - Otherwise (mounted on desktop, fully initialised) follow the current viewport so narrowing shows
 *   the prompt and widening hides it again.
 */
export function nextPlannerGateOnResize(
  initSkipped: boolean,
  currentlyGated: boolean,
  viewportWidth: number = window.innerWidth
): boolean {
  if (initSkipped) return currentlyGated;
  return isPlannerMobile(viewportWidth);
}
